import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})

export class ErrorComponent {
  code = "ERROR"
  activatedRoute = inject(ActivatedRoute)
  constructor() { 
    this.code = this.activatedRoute.snapshot.queryParams['code']
  }
}
